<template>
    <div class="row">
        <!-- GRIT -->
        <div class="col-6 col-md-4 col-lg-2 text-center">
            <img
                :src="require(`@/../public/img/grit${theme}.png`)"
                alt="grit icon"
                class="img-fluid stat-img"
                @click="requestDiceBox('grit')"
                style="cursor: pointer"
            />
            <div class="input-group">
                <input
                    type="number"
                    min="0"
                    step="1"
                    class="form-control text-center"
                    :value="getSkillInputValue('grit', stats.grit.skill)"
                    :readonly="readonly"
                    @focus="startEditing('grit')"
                    @blur="stopEditing"
                    @input="onSkillInput($event.target.value, 'grit')"
                />
                <span class="input-group-text">{{
                    Math.max(0, stats.grit.skill)
                }}</span>
            </div>
            <h5 class="text-center mt-2">Grit</h5>
            <input
                type="number"
                min="0"
                step="1"
                class="form-control text-center"
                :value="stats.grit.talent"
                :readonly="readonly"
                @input="updateTalent($event.target.value, 'grit', 'talent')"
            />
        </div>

        <!-- WIT -->
        <div class="col-6 col-md-4 col-lg-2 text-center">
            <img
                :src="require(`@/../public/img/wit${theme}.png`)"
                alt="wit icon"
                class="img-fluid stat-img"
                @click="requestDiceBox('wit')"
                style="cursor: pointer"
            />
            <div class="input-group">
                <input
                    type="number"
                    min="0"
                    step="1"
                    class="form-control text-center"
                    :value="getSkillInputValue('wit', stats.wit.skill)"
                    :readonly="readonly"
                    @focus="startEditing('wit')"
                    @blur="stopEditing"
                    @input="onSkillInput($event.target.value, 'wit')"
                />
                <span class="input-group-text">{{
                    Math.max(0, stats.wit.skill)
                }}</span>
            </div>
            <h5 class="text-center mt-2">Wit</h5>
            <input
                type="number"
                min="0"
                step="1"
                class="form-control text-center"
                :value="stats.wit.talent"
                :readonly="readonly"
                @input="updateTalent($event.target.value, 'wit', 'talent')"
            />
        </div>

        <!-- SMARTS -->
        <div class="col-6 col-md-4 col-lg-2 text-center">
            <img
                :src="require(`@/../public/img/smarts${theme}.png`)"
                alt="smarts icon"
                class="img-fluid stat-img"
                @click="requestDiceBox('smarts')"
                style="cursor: pointer"
            />
            <div class="input-group">
                <input
                    type="number"
                    min="0"
                    step="1"
                    class="form-control text-center"
                    :value="getSkillInputValue('smarts', stats.smarts.skill)"
                    :readonly="readonly"
                    @focus="startEditing('smarts')"
                    @blur="stopEditing"
                    @input="onSkillInput($event.target.value, 'smarts')"
                />
                <span class="input-group-text">{{
                    Math.max(0, stats.smarts.skill)
                }}</span>
            </div>
            <h5 class="text-center mt-2">Smarts</h5>
            <input
                type="number"
                min="0"
                step="1"
                class="form-control text-center"
                :value="stats.smarts.talent"
                :readonly="readonly"
                @input="updateTalent($event.target.value, 'smarts', 'talent')"
            />
        </div>

        <!-- HEART -->
        <div class="col-6 col-md-4 col-lg-2 text-center">
            <img
                :src="require(`@/../public/img/heart${theme}.png`)"
                alt="heart icon"
                class="img-fluid stat-img"
                @click="requestDiceBox('heart')"
                style="cursor: pointer"
            />
            <div class="input-group">
                <input
                    type="number"
                    min="0"
                    step="1"
                    class="form-control text-center"
                    :value="getSkillInputValue('heart', stats.heart.skill)"
                    :readonly="readonly"
                    @focus="startEditing('heart')"
                    @blur="stopEditing"
                    @input="onSkillInput($event.target.value, 'heart')"
                />
                <span class="input-group-text">{{
                    Math.max(0, stats.heart.skill)
                }}</span>
            </div>
            <h5 class="text-center mt-2">Heart</h5>
            <input
                type="number"
                min="0"
                step="1"
                class="form-control text-center"
                :value="stats.heart.talent"
                :readonly="readonly"
                @input="updateTalent($event.target.value, 'heart', 'talent')"
            />
        </div>

        <!-- LUCK -->
        <div class="col-6 col-md-4 col-lg-2 text-center">
            <img
                :src="require(`@/../public/img/luck${theme}.png`)"
                alt="luck icon"
                class="img-fluid stat-img"
                @click="requestDiceBox('luck')"
                style="cursor: pointer"
            />
            <div class="input-group">
                <input
                    type="number"
                    min="0"
                    step="1"
                    class="form-control text-center"
                    :value="getSkillInputValue('luck', stats.luck.skill)"
                    :readonly="readonly"
                    @focus="startEditing('luck')"
                    @blur="stopEditing"
                    @input="onSkillInput($event.target.value, 'luck')"
                />
                <span class="input-group-text">{{
                    Math.max(0, stats.luck.skill)
                }}</span>
            </div>
            <h5 class="text-center mt-2">Luck</h5>
            <input
                type="number"
                min="0"
                step="1"
                class="form-control text-center"
                :value="stats.luck.talent"
                :readonly="readonly"
                @input="updateTalent($event.target.value, 'luck', 'talent')"
            />
        </div>

        <!-- STRANGE -->
        <div class="col-6 col-md-4 col-lg-2 text-center">
            <img
                :src="require(`@/../public/img/strange${theme}.png`)"
                alt="strange icon"
                class="img-fluid stat-img"
                @click="requestDiceBox('strange')"
                style="cursor: pointer"
            />
            <div class="input-group">
                <input
                    type="number"
                    min="0"
                    step="1"
                    class="form-control text-center"
                    :value="getSkillInputValue('strange', stats.strange.skill)"
                    :readonly="readonly"
                    @focus="startEditing('strange')"
                    @blur="stopEditing"
                    @input="onSkillInput($event.target.value, 'strange')"
                />
                <span class="input-group-text">{{
                    Math.max(0, stats.strange.skill)
                }}</span>
            </div>
            <h5 class="text-center mt-2">Strange</h5>
            <input
                type="number"
                min="0"
                step="1"
                class="form-control text-center"
                :value="stats.strange.talent"
                :readonly="readonly"
                @input="updateTalent($event.target.value, 'strange', 'talent')"
            />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        stats: { type: Object, required: true },
        readonly: { type: Boolean, required: true },
        diceRoller: { type: Boolean, required: true },
        fearStatus: { type: String, required: true }, // "Stable" | "Afraid" | "Terrified"
        theme: { type: Number, required: true },
    },
    emits: ["update:stats", "roll-dice"],
    data() {
        return {
            editingSkillKey: null,
        };
    },
    computed: {
        fearMod() {
            const key = (this.fearStatus || "").toString().trim().toLowerCase();
            if (key === "afraid") return -1;
            if (key === "terrified") return -2;
            return 0;
        },
    },
    methods: {
        // While editing, show STORED; otherwise show EFFECTIVE (with min 1)
        getSkillInputValue(key, stored) {
            return this.editingSkillKey === key
                ? Math.max(0, Number(stored) || 0)
                : this.getEffectiveSkill(stored);
        },
        // Effective = stored + fearMod, but never less than 1
        getEffectiveSkill(rawSkill) {
            const stored = Math.max(0, Number(rawSkill) || 0);
            return Math.max(1, stored + this.fearMod);
        },
        startEditing(key) {
            if (this.readonly) return;
            this.editingSkillKey = key;
        },
        stopEditing() {
            this.editingSkillKey = null;
        },
        requestDiceBox(statKey) {
            const skill = this.getEffectiveSkill(this.stats[statKey].skill);
            const talent = this.stats[statKey].talent;
            this.$emit("roll-dice", { skill, talent, statKey, rolltype: "skill", monsterType: null  }); // add statKey
        },

        // Store UNMODIFIED skill (clamped to >= 0)
        onSkillInput(newValue, statCategory) {
            const parsed = parseInt(newValue, 10);
            const clamped = Number.isNaN(parsed) ? 0 : Math.max(0, parsed);
            const updatedStats = {
                ...this.stats,
                [statCategory]: { ...this.stats[statCategory], skill: clamped },
            };
            this.$emit("update:stats", updatedStats);
        },
        // Talents unaffected by fear; clamp to >= 0 for sanity
        updateTalent(newValue, statCategory, talentType) {
            const parsed = parseInt(newValue, 10);
            const clamped = Number.isNaN(parsed) ? 0 : Math.max(0, parsed);
            const updatedStats = {
                ...this.stats,
                [statCategory]: {
                    ...this.stats[statCategory],
                    [talentType]: clamped,
                },
            };
            this.$emit("update:stats", updatedStats);
        },
    },
};
</script>

<style scoped>
.stat-img {
    max-width: 50%;
    margin-bottom: 0.5rem;
}
input {
    background-color: #444;
    border: none;
    font-weight: bold;
    color: white;
}
input[type="number"] {
    text-align: center;
    -moz-appearance: textfield; /* Firefox */
}
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
.skill-display {
    font-size: 0.9rem;
    opacity: 0.85;
}
</style>

